import IndexChart from "./index-chart";
import LineChart from "./line-chart";
import RadarChart from "./radar-chart";
import BarChart from "./bar-chart";
import BubbleChart from "./bubble-chart";
import ScatterChart from "./scatter-chart/ScatterChart";
import GaugeChart from "./gauge-chart";
import PieChart from "./pie-chart";
import RangeColumnChart from "./range-column-chart";
import AreaChart from "./area-chart";

const chartModule = {
  IndexChart,
  LineChart,
  RadarChart,
  BarChart,
  BubbleChart,
  ScatterChart,
  GaugeChart,
  PieChart,
  RangeColumnChart,
  AreaChart,
};

export default chartModule;
